import moment from 'moment';
import { useState } from 'react';
import TableCompHead from '../../../../components/ui/TableCompHead';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import formatDate from '../../../../components/common/formatDate';
interface IProps {
  moduleData: any;
  isView: boolean;
}

const theadData = [
  'Sr.No.',
  'Part Code',
  'Part Name',
  'Qty',
  'Cost in Rs.',
  'Problem',
  'Reason of Problem',
  'Cost Debit to',
  'Remarks',
];

const THead = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <thead>
      <TableCompHead
        colSpan={10}
        rowSpan={3}
        labels={['Format No.:', ' Rev.No. :', 'Date:']}
        values={['FM/QMS/05', '00', '11/07/15']}
        heading="Scrap Note"
      />

      <tr>
        <th colSpan={2}>Date : </th>
        <th colSpan={8} align="left">
          {isView ? (
            formatDate(moduleData.moduleData_Date)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.moduleData_Date)}
              onChange={(date) => {
                moduleData.moduleData_Date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        {theadData.map((heading, index) => (
          <th key={heading + index} colSpan={heading === 'Remarks' ? 2 : 1}>
            {heading}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
